module.exports = __webpack_public_path__ + "media/forum/header-black-text-red-62b6ceb8.svg";